import GET_ARTICLES from '../plugins/getArticles'

const [ w, d ] = [ window, document ]

const jqReady = () => {


  // news
  $.when(w.load['block-news']).then( () => {
    let makeItem = item => $(`
      <div class="news-item">
        <a href="${item.href}" class="news-item__link">
          <figure class="news-item__img">
            <div class="news-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="240" loading="lazy"></div>
            </figure>
          <div class="news-item__body">
            <span class="cate">【${item.category.name.str_truncate(8)}】</span>
            <span class="date">${item.date}</span>
            <span class="subject">${item.title.str_truncate(24)}${item.is_new?'<small class="new">NEW</small>':''}</span>
          </div>
        </a>
      </div>
    `)[0]
    GET_ARTICLES('.block-news__list[data-plugin="getArticles"]', { makeItem })
  })
}

export default function HOME() {

  $(jqReady)

}